import styled from 'styled-components';
import CancelGreySvg from '../../assets/mytrips/cancel-grey.svg';

const CancelGreyIcon = styled(CancelGreySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.3rem'};
  height: ${props => props.height || '1.7rem'};
  margin: ${props => props.margin};
`;

export default CancelGreyIcon;
